import React from 'react';

import KatottgNode from './KatottgNode';
import { performApiRequest, KATOTTG_GETCHILDREN_API_URL} from '../../util/restapi';

const MODE_POPULATING = 'mp';
const MODE_ERROR = 'me';
const MODE_READY = 'mr';

class KatottgTree extends React.Component {

	listKatottgRoot = [];
	errorMessage = '';
	selectedNode = null;

	constructor(props) {
		super(props);
		this.state = {
			mode: MODE_POPULATING,
			selectedCode: null,
		}
	}
	componentDidMount = async () => {
		let getRootsRequest = {
			code: '',
		}
		let response = await performApiRequest( KATOTTG_GETCHILDREN_API_URL, getRootsRequest );
		if( ! response.success ) {
			this.errorMessage = response.message;
			this.setState({mode: MODE_ERROR})
			return;
		}
		this.listKatottgRoot = response.listKatottgRecord;
		this.setState({mode: MODE_READY})
	}
	setSelectedNode = (node) => {
		this.selectedNode = node;
		if( node )
			this.setState({selectedCode: node.record.code});
		else
			this.setState({selectedCode: null});
	}

	render() {
		let bodyHtml = null;
		if( this.state.mode == MODE_POPULATING ) {
			bodyHtml = (<div>...</div>)
		} else if( this.state.mode == MODE_ERROR ) {
			bodyHtml = ( <div>{this.errorMessage}</div> );
		} else if( this.state.mode == MODE_READY ) {
			bodyHtml = this.listKatottgRoot.map( (record, index) => {
				return <KatottgNode key={index} tree={this} record={record} />
			} );
		}
		return (
			<div style={{textAlign: 'left'}}>
				{bodyHtml}
			</div>
		)
	}
}

export default KatottgTree;